import PropTypes from 'prop-types';
import { camelize } from 'inflected';
import { APP_SWITCHER } from '../config';

const { TABS } = APP_SWITCHER;

export default TABS.reduce((all, key) => (
    { ...all, [`on${camelize(key)}Click`]: PropTypes.func }
), {});
